export enum EKnowledgeType {
  DIRECTLY = 'directly',
  NORMAL = 'normal',
  REQUEST = 'request',
  QUOTATION = 'quotation',
}
